import ConfirmationModal from 'components/common/ConfirmationMessage';
import { PAGELENGTH } from 'components/common/ListLayout';
import { ListLayout } from 'components/common/ListLayout';
import TableHeaderItem from 'components/common/ListLayout/TableHeaderItem';
import { usePermissions } from 'layouts/Admin';
import React, { useMemo } from 'react'
import toast from 'react-hot-toast';
import moment from "moment";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useNavigation } from 'react-router-dom';
import { DashboardSelector } from 'slices/dashboardSlice';
import { dashboardSlice } from 'slices/dashboardSlice';
import { fetchDashboardAppointments } from 'slices/dashboardSlice';
import { getEyeStyle, getBackgroundStyle } from 'components/common/TableColor';
// import { AcceptActionModal } from './AcceptActionModal';

const ListTable = ({ data }) => {
    const dispatch = useDispatch();
    const { checkPermission } = usePermissions()
    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const refAddutton = React.useRef(null);

    const [selectedItems, setSelectedItems] = React.useState([]);
    const [selectAll, setSelectAll] = React.useState(false);
    const [declineModal, setDeclineModal] = React.useState(
        {
            show: false,
            item: {}
        }
    );
    const [selectedValue, setSelectedValue] = React.useState([10])
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({
        sortBy: 'status',
        sortDirection: 'asc',
    });;
    const [sortFields, setSortFields] = React.useState([]);

    const [actionAccept, setActionAccept] = React.useState({
        show: false,
        item: {}
    });
    const { dashboard, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(DashboardSelector);

    React.useEffect(() => {
        // setSortFields([])
        // Promise.allSettled(
        //     [
        //         dispatch(fetchDashboardAppointments())
        //     ]
        // )
    }, [])

    const handleAddScheduleListPopUp = (item) => {
        setAddForm({
            show: true,
            item,
        });
    };

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            // dispatch(fetchDashboardAppointments())
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const showConfirmDialog = () => {
        setDeclineModal(true);
        return
    };
    const hideConfirmDialog = () => {
        setDeclineModal(false);
    }

    const handleDeclineConfirm = () => {
        // dispatch(declineVendorJobs({ schedule_id: declineModal?.item?.id }, submitCallback))
    }


    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };

    // const viewItemButtonRef = React.useRef()



    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {

        // const callBack = (direction, field, donotSort = false) => {
        //     setSortFields((prevConfigArray, nextConfig) => {
        //         let upgradedSortFields = [];
        //         const currentConfig = prevConfigArray.find(config => config.field === field)
        //         if (currentConfig) {
        //             upgradedSortFields = [...prevConfigArray.filter(config => config.field !== field), { field, direction }];
        //         }
        //         else {
        //             upgradedSortFields = [...prevConfigArray, { field, direction }]

        //         }
        //         // !donotSort && dispatch(fetchVendorPendingJobs(currentPage, { sortFields: JSON.stringify(upgradedSortFields), search: searchTerm }))
        //         return upgradedSortFields;
        //     });

        // }

        // const sortDirection = (field) => {
        //     const index = sortFields?.findIndex(config => config.field === field)
        //     if (index > -1) {
        //         const direction = sortFields[index].direction;
        //         return direction
        //     }
        //     return "asc"

        // }

        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchDashboardAppointments(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
        }


        return (
            <tr>
                <th>#</th>
                <th>
                    <TableHeaderItem
                        title="appid"
                        sortBy="appid"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Status"
                        sortBy="status"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Service"
                        sortBy="service"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Date"
                        sortBy="date"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Language"
                        sortBy="language"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Interpreter"
                        sortBy="interpreter"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>

                <th>
                    <TableHeaderItem
                        title="Client"
                        sortBy="accounts"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Sub Account"
                        sortBy="subaccounts"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
            </tr>
        )
    }, [selectAll, searchTerm, sortFields, currentPage, sortConfig, selectedItems]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            data?.map((item, index) => (
                <AppointmentListItem item={item} index={index} handleAcceptButton={handleAcceptButton} handleDeclineShow={handleDeclineShow} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
            ))
        )
    }, [selectedItems, data]);

    //#endregion


    const handleAcceptButton = React.useCallback((id) => {
        // viewItemButtonRef.current?.click()
        setActionAccept({
            show: true,
            item: { id },
        });

    }, [])


    const handleCloseActionButton = React.useCallback((id) => {
        // viewItemButtonRef?.current?.click()
        setActionAccept({
            show: false,
            item: {}
        })
    }, [])



    const handleDeclineShow = React.useCallback((id) => {
        // viewItemButtonRef.current?.click()
        setDeclineModal({
            show: true,
            item: { id },
        });

    }, [])


    return (
        <div className='mt-4'>

            <ListLayout
                heading={`dasboard appointments`}
                time={false}
                fullMainHead={'ms-3'}
                title=""
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                fetchList={fetchDashboardAppointments}
                selectedItems={selectedItems}
                handleDeclineConfirm={handleDeclineConfirm}
                refAddutton={refAddutton}
                addForm={addForm}
                showConfirmDialog={showConfirmDialog}
                handleAddPopUp={handleAddScheduleListPopUp}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                searchPlaceholder="Search in this table ..."
                addButtonDisabled={true}
                totalPages={totalPages}
                sortConfig={sortConfig}
            // loader={loader}


            >

                {/* <button
                    type='button'
                    hidden
                    ref={viewItemButtonRef} data-bs-toggle="modal" data-bs-target="#viewModal" className='display-none'
                /> */}
                {/* <AcceptActionModal item={actionAccept?.item} onClose={handleCloseActionButton} isOpen={actionAccept.show}/> */}

                {declineModal.show && <ConfirmationModal onClose={hideConfirmDialog} isOpen={declineModal?.show} onConfirm={handleDeclineConfirm} confirmationText="Are you sure you want to Decline?" />}

            </ListLayout>
        </div>
    )
}


const AppointmentListItem = React.memo(({
    item, index, handleAcceptButton, handleDeclineShow, current_page, pageLength, checkPermission

}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);


   
    return (
        <tr>
            <td className='p-0' style={getBackgroundStyle(item?.status)}>
                <div className={`eye_area  ${item?.appointment_details?.extra_mileage_request == 1 && 'extra-mileage'}`} style={getEyeStyle(item?.status)}>
                    <Link to={`/appointments/view/${item?.id}`}><i class="fa-solid fa-eye"></i></Link>
                </div>
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.appid || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)} className='text-transform-capitalize '>
                {item?.status || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.type || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                { moment(item?.datetime, 'YYYY-MM-DD hh:mm A').format('MMM D, YYYY hh:mm A') || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.language?.name || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.interpreter?.user?.name || 'N/A'}
            </td>
            <td style={getBackgroundStyle(item?.status)}>
                {item?.accounts?.user?.name || 'N/A'}
            </td>
             <td style={getBackgroundStyle(item?.status)}>
                {item?.subclient?.subaccount_name || 'N/A'}
            </td>
        </tr>
    )
})
export default ListTable